import React from 'react'
import { usePutRequest } from '../hooks/request'
import ServerError from './componentsFinance/common/ServerError'
import ResultItemForm from './ResultItemForm'
import { RESULT_ITEM_DETAIL } from '../urls'

export default function ResultItemUpdate({ onCancel, onSuccess, reportItem, finance, rotationId }) {
    const url = RESULT_ITEM_DETAIL.replace('{id}', reportItem.id)
    const rotationItemUpdate = usePutRequest({ url })

    async function onSubmit(data) {
        const { success } = await rotationItemUpdate.request({ data })

        if (success) {
            onSuccess()
        }
    }

    return (
        <div>
            <b>Изменить данные</b><br /><br />
            <ServerError error={rotationItemUpdate.error} />
            <ResultItemForm
                initialValues={reportItem}
                onSubmit={onSubmit}
                onCancel={onCancel}
                rotationId={rotationId}
                finance={finance}
                loading={rotationItemUpdate.loading} />
        </div>
    )
}
